import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '~/lib/utils';

const Card = React.forwardRef(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn('rounded-[1.25rem] border border-border/80 bg-card/95 text-card-foreground shadow-card backdrop-blur-sm', className)}
		{...props}
	/>
));
Card.displayName = 'Card';
Card.propTypes = { className: PropTypes.string };

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
	<div ref={ref} className={cn('p-5', className)} {...props} />
));
CardContent.displayName = 'CardContent';
CardContent.propTypes = { className: PropTypes.string };

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
	<div ref={ref} className={cn('flex flex-col space-y-1.5 p-5', className)} {...props} />
));
CardHeader.displayName = 'CardHeader';
CardHeader.propTypes = { className: PropTypes.string };

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
	<h3 ref={ref} className={cn('text-lg font-semibold leading-none tracking-tight', className)} {...props} />
));
CardTitle.displayName = 'CardTitle';
CardTitle.propTypes = { className: PropTypes.string };

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
	<p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
));
CardDescription.displayName = 'CardDescription';
CardDescription.propTypes = { className: PropTypes.string };

export { Card, CardContent, CardDescription, CardHeader, CardTitle };
